import { render, staticRenderFns } from "./impact-side-nav.vue?vue&type=template&id=66648376"
import script from "./impact-side-nav.ts?vue&type=script&lang=ts&external"
export * from "./impact-side-nav.ts?vue&type=script&lang=ts&external"
import style0 from "./impact-side-nav.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports